import adminApiClient from '../../api/base/adminApiClient'

export interface AppVersionRow {
  /** 'ios' | 'android' — 버전을 안 보낸 사용자는 null */
  platform: string | null
  version: string | null
  build: string | null
  users: number
  lastSeen: string | null
}

export interface AppVersionsResponse {
  data: {
    days: number
    total: number
    /** 버전을 한 번도 안 보낸 사용자 수 */
    unknown: number
    versions: AppVersionRow[]
  }
}

export interface AppUpdateSetting {
  is_enabled: boolean
  ios_min_version: string | null
  android_min_version: string | null
  block_unknown_version: boolean
}

export const adminAppVersionApi = {
  getAppVersions: async (days: number): Promise<AppVersionsResponse> => {
    const response = await adminApiClient.get<AppVersionsResponse>(
      '/admin/app-versions',
      { params: { days } }
    )
    return response.data
  },

  getAppUpdateSetting: async (): Promise<{ data: AppUpdateSetting }> => {
    const response = await adminApiClient.get<{ data: AppUpdateSetting }>(
      '/admin/app-update-setting'
    )
    return response.data
  },

  updateAppUpdateSetting: async (
    payload: AppUpdateSetting
  ): Promise<{ message: string; data: AppUpdateSetting }> => {
    const response = await adminApiClient.put<{
      message: string
      data: AppUpdateSetting
    }>('/admin/app-update-setting', payload)
    return response.data
  },
}
